export default __webpack_public_path__ + "static/media/design.74bc0eb4.webp";